<template>
<div>
  <b-row v-if="isMobile" align-h="center">
    <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
      <b-alert :show="alertDesc !== ''" variant="warning">{{
        alertDesc
      }}</b-alert>
      <h3>
        Enter ZIP Codes
      </h3>
      <div class="zipr-box">
        <div class="zip-code-box">
          <div class="zip-input-box" v-for="(item, index) in zips">
            <b-input
              class="zip-input"
              :id="'zip' + index"
              maxlength="5"
              inputmode="numeric" 
              pattern="[0-9]*"
              v-model="item.zip"
              @input="nextInput(index, $event)"
              @change="$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])"
            >
            </b-input>
          </div>
        </div>
        <b-btn
          variant="primary"
          :disabled="nextDisabled"
          style="display: none"
          data-test="geo-zip-add"
          @click="addZip"
          >Add
        </b-btn>
      </div>
    </b-col>
  </b-row>
  <div v-else class="dbox">
    <b-alert :show="alertDesc!==''" variant="warning">{{alertDesc}}</b-alert>

    <!-- input -->
    <div class="box">
      <div class="header" @click="switchmenu('zip')">
        <h3>
          <icon v-show="step === 'zip'" name="chevron-down" class="h3-icon"/>
          <icon v-show="step !== 'zip'" name="chevron-right" class="h3-icon"/>
          Enter ZIP Codes
        </h3>
      </div>
      <div v-show="step === 'zip'" class="zipr-box ">
        <div class="zip-code-box">
          <div class="zip-input-box" v-for="(item,index) in zips">
            <b-input class="zip-input" :id="'zip'+index"
                     maxlength="5"
                     v-model="item.zip"
                     @input="nextInput(index,$event)"
                     @change="$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])">
            </b-input>
          </div>
        </div>
        <b-btn variant="primary"
               :disabled="nextDisabled"
               style="display: block"
               data-test="geo-zip-add"
               @click="addZip">Add
        </b-btn>
      </div>
    </div>

    <!-- paste -->
    <div class="box">
      <div class="header" @click="switchmenu('pastezip')">
        <h3>
          <icon v-show="step === 'pastezip'" name="chevron-down" class="h3-icon"/>
          <icon v-show="step !== 'pastezip'" name="chevron-right" class="h3-icon"/>
          Paste ZIP Codes<span v-show="showZip4">, ZIP+4</span> or Carrier Routes
        </h3>
      </div>

      <div v-show="step=='pastezip'" class="zipr-box">
        <div class="zipbox">
          <b-form-textarea id="textarea1"
                           v-model="zipDesc"
                           placeholder="Copy and paste up to 2,000 areas separated by a comma, space, or semicolon, or that wrap with one per line."
                           @change="$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])"
                           :rows="5"
                           :max-rows="8">
          </b-form-textarea>
        </div>
        <b-form-select v-model="pastZipType" style="display: inline-block; width: 300px; margin-right: 16px;">
          <option value="zip">ZIP Codes</option>
          <option value="zip4" v-show="showZip4">ZIP+4</option>
          <option value="carrierRoutes">Carrier Routes</option>
        </b-form-select>
        <b-btn variant="primary"
                  :disabled="nextDisabled"
                  @click="pastedZip(false)">Add
        </b-btn>
      </div>
    </div>

    <!-- map -->
    <div class="box">
      <div class="header" @click="switchmenu('map')">
        <h3>
          <icon v-show="step === 'map'" name="chevron-down" class="h3-icon"/>
          <icon v-show="step !== 'map'" name="chevron-right" class="h3-icon"/>
          Select ZIP Codes from Map
        </h3>
      </div>
      <keep-alive class="zipr-box">
        <m-geo-zip-map  v-if="step === 'map'" :geoType="geoType" :pastZipType="pastZipType"/>
      </keep-alive>
    </div>

    <!-- range -->
    <div class="box">
      <div class="header" @click="switchmenu('rangezip')">
        <h3>
          <icon v-show="step === 'rangezip'" name="chevron-down" class="h3-icon"/>
          <icon v-show="step !== 'rangezip'" name="chevron-right" class="h3-icon"/>
          Enter ZIP Code Range
        </h3>
      </div>
      <div v-show="step=='rangezip'" class="zip-content-box">
        <div class="zipbox">
          <b-input v-model="zipFrom"
                   maxlength="5"
                   @input="fromChange($event)"
                   class="zip-inputr"
                   @change="$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])"></b-input>
          <span class="to">to</span>
          <b-input v-model="zipTo"
                   class="zip-inputr zip-to"
                   id="zipto"
                   maxlength="5"
                   @blur="pastedZip(true)"
                   @change="$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])"></b-input>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MGeoZipMap from "@/components/geo/MGeoZipMap";

export default {
  components: { MGeoZipMap },
  props: {
    geoType: {
      type: Number,
    },
    changeGeoType: {
      type: Number,
      default: 5,
    },
    isGo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      zips: [],
      zipDesc: "",
      zipType: 1,
      zipFrom: "",
      zipTo: "",
      step: "zip",
      nextDisabled: false,
      alertDesc: "",
      needCb: false,
      pastZipType: "zip", // 'zip', 'zip4', 'carrierRoutes'
      zipExample: {
        zip: "ZIP Code(e.g. 10025",
        zip4: "ZIP+4(e.g. 071100001",
        carrierRoutes: "Carrier Routes (e.g. 07110:B001",
      },
      zipsType: {
        zip: 1,
        zip4: 2,
        carrierRoutes: 3,
      },
    };
  },
  computed: {
    realGeoType() {
      return this.$store.state.geo.geoTypes.Zip;
    },
    zipTypes() {
      return this.$store.state.geo.zipTypes;
    },
    // TODO@Pony need update
    geoItems() {
      return this.$store.getters["order/geoItems"];
    },
    showZip4() {
      return this.$store.state.order.ListType !== 50;
    },
    isMobile () {
      return this.$store.state.config.isMobile
    }
  },
  watch: {
    isGo(val) {
      if (val) {
        this.next();
      }
    },
  },
  created() {
    // add zips
    for (let i = 0; i < 15; i++) {
      this.zips.push({ zip: "" });
    }
  },
  methods: {
    next() {
      this.alertDesc = "";
      if (this.step === "zip") {
        this.addZip();
      } else if (this.step === "rangezip") {
        this.rangeaddZip();
      } else if (this.step === "pastezip") {
        this.pastedZip();
      } else if (this.geoItems.length === 0) {
        this.alertDesc = "Please input ZIP Code.";
        this.unlock();
      } else {
        this.unlock();
      }
    },
    addZip() {
      if (this.pastZipType !== "zip") {
        this.$store.commit("order/cleanGeo");
        this.$store.commit("order/saveKey", ["ZipType", 0]);
      }

      // read zip from input
      this.lock();
      let zipInputs = JSON.parse(JSON.stringify(this.zips));
      let zips = [];
      for (let zip of zipInputs) {
        if (zip.zip) {
          zips.push(zip.zip);
        }
      }
      if (zips.length === 0 && this.geoItems.length > 0 && this.isGo) {
        this.unlock();
        return;
      } else if (zips.length === 0) {
        this.alertDesc = "Please input at least one ZIP Code.";
        this.unlock();
        return;
      }

      // check zip
      this.$http
        .post("PlaceOrder.aspx/GetZipsByZips", {
          zipType: 1,
          zips: zips,
        })
        .then(
          (resp) => {
            // add zip to order
            let respZips = resp.body.d.DataSource;
            if (respZips.length !== zips.length) {
              this.alertDesc =
                "Please enter the correct ZIP codes. Invalid or duplicate entries have been removed.";
              this.$emit("update:isGo", false);
            }
            if (respZips.length === 0 && this.geoItems.lenght === 0) {
              this.alertDesc =
                "Please input at least one valid zip. Invalid or duplicate entries have been removed.";
              this.$emit("update:isGo", false);
            }
            for (let zip of respZips) {
              this.$store.commit("order/addGeo", {
                GeoKeyCode: zip,
                GeoKeyDesc: zip,
                GeoType: 5,
              });
            }
            this.unlock();
          },
          (resp) => {
            this.unlock();
          }
        );
      for (let item of this.zips) {
        item.zip = "";
      }
    },
    selectGeoType() {
      if (this.order.GeoType !== this.geoType.code) {
      }
    },
    pastedZip(isRange) {
      let pastZipType = this.pastZipType;
      if (isRange) {
        if (this.pastZipType !== "zip") {
          this.$store.commit("order/cleanGeo");
        }
        pastZipType = "zip";
      }
      this.$store.commit("order/saveKey", [
        "ZipType",
        this.zipsType[pastZipType],
      ]);
      this.lock();
      if (this.zipDesc === "" && this.geoItems.length > 0 && this.isGo) {
        this.unlock();
        return;
      } else if (this.zipDesc === "") {
        this.alertDesc =
          "Please input at least one valid " +
          this.zipExample[pastZipType] +
          ").";
        this.unlock();
        return;
      }

      let zips = this.zipDesc.split(/[\s,;]/);
      this.$http
        .post("PlaceOrder.aspx/GetZipsByZips", {
          zipType: this.zipsType[pastZipType],
          zips: zips,
        })
        .then(
          (resp) => {
            let respZips = resp.body.d.DataSource;
            if (respZips.length !== zips.length || respZips.length === 0) {
              this.alertDesc =
                "Please enter the correct " +
                this.zipExample[pastZipType] +
                "). Invalid or duplicate entries have been removed.";
            }
            for (let zip of respZips) {
              this.$store.commit("order/addGeo", {
                GeoKeyCode: zip,
                GeoKeyDesc: zip,
                GeoType: 5,
              });
            }
            this.unlock();
          },
          (resp) => {
            this.unlock();
          }
        );
      this.zipDesc = "";
    },
    validZip(zips) {
      this.$http
        .post("PlaceOrder.aspx/GetZipsByZips", {
          zipType: 0,
          zips: zips,
        })
        .then(
          (resp) => {
            // add zip to order
            let zips = resp.body.d.DataSource;
            if (zips.length === 0) {
              this.alertDesc =
                "Please input at least one valid zip. Invalid or duplicate entries have been removed.";
            }
            for (let zip of zips) {
              this.$store.commit("order/addGeo", {
                GeoKeyCode: zip,
                GeoKeyDesc: zip,
                GeoType: 5,
              });
            }
            this.zipFrom = "";
            this.zipTo = "";
            this.unlock();
          },
          (resp) => {
            this.unlock();
          }
        );
    },
    rangeaddZip() {
      this.lock();
      if (this.pastZipType !== "zip") {
        this.$store.commit("order/cleanGeo");
        this.$store.commit("order/saveKey", ["ZipType", 0]);
      }
      if (
        (this.zipFrom === "" || this.zipTo === "") &&
        this.geoItems.length > 0 &&
        this.isGo
      ) {
        this.unlock();
        return;
      } else if (this.zipFrom === "" || this.zipTo === "") {
        this.alertDesc = "Please input ZIP Code.";
        this.unlock();
        return;
      }

      this.$http
        .post("PlaceOrder.aspx/GetZipcodesByRange", {
          fromZipcode: this.zipFrom,
          toZipcode: this.zipTo,
          maxLength: 2000,
        })
        .then(
          (resp) => {
            this.validZip(resp.body.d.DataSource);
          },
          (resp) => {
            this.unlock();
          }
        );
    },
    switchmenu(val) {
      if (this.step !== val) {
        this.step = val;
      } else {
        if (this.step === "zip") {
          this.step = "";
        } else if (this.step === "map") {
          this.step = "";
        } else if (this.step === "pastezip") {
          this.step = "";
        } else {
          this.step = "";
        }
      }
    },
    lock() {
      this.$store.dispatch("order/changeGeoType", this.changeGeoType);
      this.nextDisabled = true;
      this.alertDesc = "";
    },
    unlock() {
      this.nextDisabled = false;
      this.$emit("update:isGo", false);

      if (this.isGo & (this.alertDesc === "")) {
        this.$store.dispatch("geo/next", true);
      }
    },
    fromChange(v) {
      if (v.length === 5) {
        document.getElementById("zipto").focus();
      }
    },
    nextInput(index, v) {
      if (v.length === 5 && index < 24) {
        document.getElementById("zip" + (index + 1)).focus();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dbox {
  width: 100%;
}

.zip-code-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.zip-input-box {
  margin: 0;
  padding-left: 8px;
  padding-right: 8px;
  width: 33%;
}

@media (max-width: 576px) {
  .zip-input-box {
    width: 100%;
  }
}

.zip-input {
  width: 100%;
  border: 1px solid $color-input-border;
  margin-bottom: 1em;
  margin-right: 1em;
}

.box {
  border: 1px solid $color-border;
  border-radius: 8px;
  background-color: $color-background;
  padding: 10px 10px 10px 10px;
  width: 100%;
  margin-bottom: 10px;
  display: block !important;
}

.header {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;
}

.zipbox {
  margin-bottom: 16px;
  display: flex;
  border: 0;
  justify-content: space-between;
  align-items: center;
}

.zip-to {
}

.zip-inputr {
  max-width: 200px;
  display: inline-block;
}

.zipr-box {
  padding-bottom: 10px;
  margin-top: 16px;
}
.h3-icon {
  margin-right: 8px;
}

.zip-content-box {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}
.to {
  margin-left: 16px;
  margin-right: 16px;
}

@media (max-width: 768px) {
  .zip-input-box {
    width: 50%;
  }
  .zip-to {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/geo/MGeoZip.vue